export const NAMESPACE = 'jbp-key-initiatives'

export const DESCRIPTION_QUALITY_REASON_TRANSLATION_PREFIX =
  'jbp-key-initiatives-description-quality-reason-'

export const TRANSLATION_KEYS = {
  businessPrioritiesRequired: `${NAMESPACE}-business-priorities-required`,
  capabilitiesPillar: {
    columns: {
      nameDescription: `${NAMESPACE}-capabilities-pillar-column-name-description`,
      owner: `${NAMESPACE}-capabilities-pillar-column-owner`,
    },
  },
  listView: {
    title: `${NAMESPACE}-list-view-title`,
    noGrouping: `${NAMESPACE}-list-view-no-grouping`,
    groupBy: {
      strategicInitiative: `${NAMESPACE}-list-view-group-by-strategic-initiative`,
      businessPriority: `${NAMESPACE}-list-view-group-by-business-priority`,
      businessUnit: `${NAMESPACE}-list-view-group-by-business-unit`,
      period: `${NAMESPACE}-list-view-group-by-period`,
      status: `${NAMESPACE}-list-view-group-by-status`,
    },
    countMeasure: `${NAMESPACE}-list-view-count-measure`,
    businessUnit: `${NAMESPACE}-list-view-business-unit`,
    notSpecified: `${NAMESPACE}-list-view-not-specified`,
    collapseAll: `${NAMESPACE}-list-view-collapse-all`,
    expandAll: `${NAMESPACE}-list-view-expand-all`,
    summary: `${NAMESPACE}-list-view-summary`,
    summaryGrouped: `${NAMESPACE}-list-view-summary-grouped`,
    total: `${NAMESPACE}-list-view-total`,
    empty: `${NAMESPACE}-list-view-empty`,
    emptyFiltered: `${NAMESPACE}-list-view-empty-filtered`,
    search: `${NAMESPACE}-list-view-filter-search`,
    clearAll: `${NAMESPACE}-list-view-filter-clear-all`,
    clearSection: `${NAMESPACE}-list-view-filter-clear-section`,
    showing: `${NAMESPACE}-list-view-filter-showing`,
    removeFilter: `${NAMESPACE}-list-view-filter-remove`,
    goalMode: `${NAMESPACE}-list-view-filter-goal-mode`,
    fundingSource: `${NAMESPACE}-list-view-filter-funding-source`,
    noFilterMatches: `${NAMESPACE}-list-view-filter-no-matches`,
    edit: `${NAMESPACE}-list-view-edit`,
    remove: `${NAMESPACE}-list-view-remove`,
    period: {
      fullYear: `${NAMESPACE}-list-view-period-full-year`,
      h1: `${NAMESPACE}-list-view-period-h1`,
      h2: `${NAMESPACE}-list-view-period-h2`,
    },
  },
  disclaimerBanner: {
    groupByPeriod: `${NAMESPACE}-disc-banner-group-by-period`,
    groupByPriority: `${NAMESPACE}-disc-banner-group-by-priority`,
  },
  requirements: {
    intro: `${NAMESPACE}-requirements-intro`,
    whatWeScore: `${NAMESPACE}-requirements-what-we-score`,
    getStarted: `${NAMESPACE}-requirements-get-started`,
    low: `${NAMESPACE}-requirements-low`,
    moderate: `${NAMESPACE}-requirements-moderate`,
    high: `${NAMESPACE}-requirements-high`,
    copyKIDialog: {
      text: `${NAMESPACE}-requirements-copy-ki-dialog-text`,
      title: `${NAMESPACE}-requirements-copy-ki-dialog-title`,
      submit: `${NAMESPACE}-requirements-copy-ki-dialog-submit`,
      cancel: `${NAMESPACE}-requirements-copy-ki-dialog-cancel`,
    },
  },
  copyFromPreviousYear: {
    title: `${NAMESPACE}-copy-from-previous-year-title`,
    description: `${NAMESPACE}-copy-from-previous-year-description`,
    open: `${NAMESPACE}-copy-from-previous-year-open`,
    empty: `${NAMESPACE}-copy-from-previous-year-empty`,
    loadError: `${NAMESPACE}-copy-from-previous-year-load-error`,
    copyError: `${NAMESPACE}-copy-from-previous-year-copy-error`,
    retry: `${NAMESPACE}-copy-from-previous-year-retry`,
    columns: {
      name: `${NAMESPACE}-copy-from-previous-year-column-name`,
      description: `${NAMESPACE}-copy-from-previous-year-column-description`,
      strategicInitiative: `${NAMESPACE}-copy-from-previous-year-column-strategic-initiative`,
      businessUnit: `${NAMESPACE}-copy-from-previous-year-column-business-unit`,
      businessPriorities: `${NAMESPACE}-dashboard-table-columns-business-priorities`,
      period: `${NAMESPACE}-dashboard-table-columns-period`,
      finGoalType: `${NAMESPACE}-dashboard-table-columns-fin-goal-type`,
      finGoal: `${NAMESPACE}-dashboard-table-columns-fin-goal`,
      validation: `${NAMESPACE}-copy-from-previous-year-column-validation`,
    },
    actions: {
      validate: `${NAMESPACE}-copy-from-previous-year-validate`,
      copy: `${NAMESPACE}-copy-from-previous-year-copy`,
      close: `${NAMESPACE}-copy-from-previous-year-close`,
      ok: `${NAMESPACE}-copy-from-previous-year-ok`,
      selectAll: `${NAMESPACE}-copy-from-previous-year-select-all`,
      selectInitiative: `${NAMESPACE}-copy-from-previous-year-select-initiative`,
      edit: `${NAMESPACE}-copy-from-previous-year-edit`,
    },
    validation: {
      queued: `${NAMESPACE}-copy-from-previous-year-validation-queued`,
      validating: `${NAMESPACE}-copy-from-previous-year-validation-validating`,
      valid: `${NAMESPACE}-copy-from-previous-year-validation-valid`,
      invalid: `${NAMESPACE}-copy-from-previous-year-validation-invalid`,
      alreadyCopied: `${NAMESPACE}-copy-from-previous-year-validation-already-copied`,
      warningTitle: `${NAMESPACE}-copy-from-previous-year-validation-warning-title`,
      warningText: `${NAMESPACE}-copy-from-previous-year-validation-warning-text`,
      footerWarning: `${NAMESPACE}-copy-from-previous-year-validation-footer-warning-edit-and-copy`,
      issues: {
        nameRequired: `${NAMESPACE}-copy-from-previous-year-validation-name-required`,
        nameTooLong: `${NAMESPACE}-copy-from-previous-year-validation-name-too-long`,
        descriptionRequired: `${NAMESPACE}-copy-from-previous-year-validation-description-required`,
        descriptionQuality: `${NAMESPACE}-copy-from-previous-year-validation-description-quality`,
        descriptionQualityUnavailable: `${NAMESPACE}-copy-from-previous-year-validation-description-quality-unavailable`,
        strategicInitiative: `${NAMESPACE}-copy-from-previous-year-validation-strategic-initiative`,
        businessUnit: `${NAMESPACE}-copy-from-previous-year-validation-business-unit`,
        businessPriorities: `${NAMESPACE}-business-priorities-required`,
        period: `${NAMESPACE}-copy-from-previous-year-validation-period`,
        status: `${NAMESPACE}-copy-from-previous-year-validation-status`,
        funding: `${NAMESPACE}-copy-from-previous-year-validation-funding`,
        financialTarget: `${NAMESPACE}-copy-from-previous-year-validation-financial-target`,
        activityType: `${NAMESPACE}-copy-from-previous-year-validation-activity-type`,
      },
    },
  },
  scoreCards: {
    financialPlanCoverage: {
      title: `${NAMESPACE}-financial-plan-coverage-title`,
      description: `${NAMESPACE}-financial-plan-coverage-description`,
    },

    descriptionQuality: {
      title: `${NAMESPACE}-description-quality-title`,
      description: `${NAMESPACE}-description-quality-description`,
    },

    strategicGrowthAreas: {
      title: `${NAMESPACE}-strategic-growth-areas-title`,
      description: `${NAMESPACE}-strategic-growth-areas-description`,
    },
  },
  actionCards: {
    completeFinPlan: {
      title: `${NAMESPACE}-complete-fin-plan-title`,
      description: `${NAMESPACE}-complete-fin-plan-description`,
    },

    createInitiative: {
      title: `${NAMESPACE}-create-initiative-title`,
      description: `${NAMESPACE}-create-initiative-description`,
    },

    clonePreviousYear: {
      title: `${NAMESPACE}-clone-previous-year-title`,
      description: `${NAMESPACE}-clone-previous-year-description`,
    },
  },

  dashboard: {
    rollupMode: `${NAMESPACE}-dashboard-rollup-mode`,
    filters: {
      title: `${NAMESPACE}-dashboard-filters-title`,
      strategicInitiative: `${NAMESPACE}-dashboard-filters-strategic-initiative`,
      businessPriority: `${NAMESPACE}-dashboard-filters-business-priority`,
      geo: `${NAMESPACE}-dashboard-filters-business-geo`,
      status: `${NAMESPACE}-dashboard-filters-status`,

      strategicInitiativeBubble: `${NAMESPACE}-dashboard-filters-strategic-initiative-bubble`,
      businessPriorityBubble: `${NAMESPACE}-dashboard-filters-business-priority-bubble`,
      geoBubble: `${NAMESPACE}-dashboard-filters-business-geo-bubble`,
      statusBubble: `${NAMESPACE}-dashboard-filters-status-bubble`,
      resetBubble: `${NAMESPACE}-dashboard-filters-reset-bubble`,

      resetFilters: `${NAMESPACE}-dashboard-filters-reset-filters`,
      close: `${NAMESPACE}-dashboard-filters-reset-close`,
    },
    controls: {
      title: `${NAMESPACE}-dashboard-controls-title`,
      groupBy: `${NAMESPACE}-dashboard-controls-group-by`,
      chartMeasure: `${NAMESPACE}-dashboard-controls-chart-measure`,
      currency: `${NAMESPACE}-dashboard-controls-currency`,
      unitsMeasure: `${NAMESPACE}-dashboard-controls-units-measure`,
    },

    aggregatedView: {
      initiativesByStatus: {
        title: `${NAMESPACE}-aggregated-view-ki-by-status-title`,
      },
      totalGoal: {
        title: `${NAMESPACE}-aggregated-view-total-goal-title`,
        footer: `${NAMESPACE}-aggregated-view-total-goal-footer`,
      },

      incremental: {
        title: `${NAMESPACE}-aggregated-view-incremental-title`,
        footer: `${NAMESPACE}-aggregated-view-incremental-footer`,
      },

      done: {
        title: `${NAMESPACE}-aggregated-view-done-title`,
        footer: `${NAMESPACE}-aggregated-view-done-footer`,
      },
    },

    charts: {
      spBi: {
        title: `${NAMESPACE}-dashboard-charts-sp-bi-title`,
        subTitle: `${NAMESPACE}-dashboard-charts-sp-bi-sub-title`,
        text1: `${NAMESPACE}-dashboard-charts-sp-bi-text1`,
        text2: `${NAMESPACE}-dashboard-charts-sp-bi-text2`,
        siBp: `${NAMESPACE}-dashboard-charts-sp-bi-si-bp`,
        siPerBp: `${NAMESPACE}-dashboard-charts-sp-bi-si-per-bp`,
        bpPerSi: `${NAMESPACE}-dashboard-charts-sp-bi-bp-per-si`,
      },
      initiativesBar: {
        title: `${NAMESPACE}-dashboard-charts-ki-bar-title`,
        subTitle: `${NAMESPACE}-dashboard-charts-ki-bar-subTitle`,
      },
      coverageBar: {
        title: `${NAMESPACE}-dashboard-charts-coverage-bar-title`,
        subTitle: `${NAMESPACE}-dashboard-charts-ki-coverage-subTitle`,
      },
    },

    table: {
      createNew: `${NAMESPACE}-dashboard-table-create-new`,
      export: `${NAMESPACE}-dashboard-table-export`,
      finGoalTypeNoSalesTarget: `${NAMESPACE}-goal-mode-no-sales-target-table`,
      initiativesCountOne: `${NAMESPACE}-dashboard-table-initiatives-count-one`,
      initiativesCountMany: `${NAMESPACE}-dashboard-table-initiatives-count-many`,
      columns: {
        name: `${NAMESPACE}-dashboard-table-columns-name`,
        description: `${NAMESPACE}-dashboard-table-columns-description`,
        strategicInitiative: `${NAMESPACE}-dashboard-table-columns-strategic-initiative`,
        businessPriorities: `${NAMESPACE}-dashboard-table-columns-business-priorities`,
        period: `${NAMESPACE}-dashboard-table-columns-period`,
        status: `${NAMESPACE}-dashboard-table-columns-status`,
        finGoalType: `${NAMESPACE}-dashboard-table-columns-fin-goal-type`,
        finGoal: `${NAMESPACE}-dashboard-table-columns-fin-goal`,
        goal: `${NAMESPACE}-dashboard-table-columns-goal`,
        incremental: `${NAMESPACE}-dashboard-table-columns-incremental`,
        market: `${NAMESPACE}-dashboard-table-columns-market`,
        country: `${NAMESPACE}-dashboard-table-columns-country`,
        partnerName: `${NAMESPACE}-dashboard-table-columns-partnerName`,
      },
    },
  },

  quality: {
    title: `${NAMESPACE}-quality-title`,
    subtitle: `${NAMESPACE}-quality-subtitle`,
    notApplicable: `${NAMESPACE}-quality-not-applicable`,
    quickFilter: {
      withoutFinancialTargets: `${NAMESPACE}-quality-quick-filter-without-financial-targets`,
      lowDescriptionQuality: `${NAMESPACE}-quality-quick-filter-low-description-quality`,
      withoutBusinessPriorities: `${NAMESPACE}-quality-quick-filter-without-business-priorities`,
    },

    overall: {
      title: `${NAMESPACE}-quality-overall-title`,
      score: `${NAMESPACE}-quality-overall-score`,
    },

    actions: {
      howWeScore: `${NAMESPACE}-quality-actions-how-we-score`,
      createIncrementalInitiative: `${NAMESPACE}-quality-actions-create-incremental-initiative`,
      viewCoverage: `${NAMESPACE}-quality-actions-view-coverage`,
      hideCoverage: `${NAMESPACE}-quality-actions-hide-coverage`,
      hideDetailsFin: `${NAMESPACE}-quality-actions-hide-details-fin`,
      showDetailsFin: `${NAMESPACE}-quality-actions-show-details-fin`,
      hideDetailsDesc: `${NAMESPACE}-quality-actions-hide-details-desc`,
      showDetailsDesc: `${NAMESPACE}-quality-actions-show-details-desc`,
    },

    details: {
      name: `${NAMESPACE}-quality-details-name`,
      description: `${NAMESPACE}-quality-details-description`,
      suggestions: `${NAMESPACE}-quality-details-suggestions`,
      goal: `${NAMESPACE}-quality-details-goal`,
      incremental: `${NAMESPACE}-quality-details-incremental`,
      edit: `${NAMESPACE}-quality-details-edit`,
    },

    financialPlanCoverage: {
      title: `${NAMESPACE}-quality-financial-plan-coverage-title`,
      notApplicable: `${NAMESPACE}-quality-financial-plan-coverage-not-applicable`,
      description: `${NAMESPACE}-quality-financial-plan-coverage-description`,
      success: `${NAMESPACE}-quality-financial-plan-coverage-success`,
    },

    descriptionQuality: {
      title: `${NAMESPACE}-quality-description-quality-title`,
      description: `${NAMESPACE}-quality-description-quality-description`,
      success: `${NAMESPACE}-quality-description-quality-success`,
    },

    strategicAlignment: {
      groupSummary: `${NAMESPACE}-quality-strategic-alignment-group-summary`,
      mdfGroup: `${NAMESPACE}-quality-strategic-alignment-mdf-group`,
      priorityGroup: `${NAMESPACE}-quality-strategic-alignment-priority-group`,
      scoreLabel: `${NAMESPACE}-quality-strategic-alignment-score-label`,
      cappedScore: `${NAMESPACE}-quality-strategic-alignment-capped-score`,
      overlapOne: `${NAMESPACE}-quality-strategic-alignment-overlap-one`,
      overlapMany: `${NAMESPACE}-quality-strategic-alignment-overlap-many`,
      scoreContributions: `${NAMESPACE}-quality-strategic-alignment-score-contributions`,
      low: `${NAMESPACE}-quality-strategic-alignment-low`,
      moderate: `${NAMESPACE}-quality-strategic-alignment-moderate`,
      high: `${NAMESPACE}-quality-strategic-alignment-high`,
      title: `${NAMESPACE}-quality-strategic-alignment-title`,
      conditionsMet: `${NAMESPACE}-quality-strategic-alignment-conditions-met`,
      showBreakdown: `${NAMESPACE}-quality-strategic-alignment-show-breakdown`,
      hideBreakdown: `${NAMESPACE}-quality-strategic-alignment-hide-breakdown`,
      mdfInitiative: `${NAMESPACE}-quality-strategic-alignment-mdf-initiative`,
      businessPriority: `${NAMESPACE}-quality-strategic-alignment-business-priority`,
      mdfHint: `${NAMESPACE}-quality-strategic-alignment-mdf-hint`,
      businessPriorityHint: `${NAMESPACE}-quality-strategic-alignment-business-priority-hint`,
      met: `${NAMESPACE}-quality-strategic-alignment-met`,
      notMet: `${NAMESPACE}-quality-strategic-alignment-not-met`,
      metByOne: `${NAMESPACE}-quality-strategic-alignment-met-by-one`,
      metByMany: `${NAMESPACE}-quality-strategic-alignment-met-by-many`,
      showWithoutPriority: `${NAMESPACE}-quality-strategic-alignment-show-without-priority`,
      hideWithoutPriority: `${NAMESPACE}-quality-strategic-alignment-hide-without-priority`,
      allHavePriority: `${NAMESPACE}-quality-strategic-alignment-all-have-priority`,
      scoreDescription: `${NAMESPACE}-quality-strategic-alignment-score-description`,
    },
    strategicGrowthAreas: {
      title: `${NAMESPACE}-quality-strategic-growth-areas-title`,
      description: `${NAMESPACE}-quality-strategic-growth-areas-description`,
      coverageTitle: `${NAMESPACE}-quality-strategic-growth-areas-coverage-title`,
      initiativesCountOne: `${NAMESPACE}-quality-strategic-growth-areas-initiatives-count-one`,
      initiativesCountMany: `${NAMESPACE}-quality-strategic-growth-areas-initiatives-count-many`,
    },
  },
}
